import { Button } from "@/src/components/ui/button";
import { Content } from "@/src/components/wrappers/Content";
import { Link, Outlet } from "react-router-dom";
import { ActionsContext, useEmit } from "../../lib/actions";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../components/ui/dialog";
import { FiltersForm } from "./FiltersForm/FiltersForm";
import { ActionButton } from "../../components/wrappers/WithActionBar";
import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { useYachtsStore } from "../../stores/yachtsStore";
import { PlusIcon } from "lucide-react";

export function Yachts() {
  const [visible, setVisible] = useState(false);
  const { filters } = useYachtsStore();

  return (
    <ActionsContext>
      <Content
        title="Yachts"
        contentAction={
          <Button asChild>
            <Link to="/yachts/add">
              Add a non-API yacht
              <PlusIcon className="ml-2" size={16} />
            </Link>
          </Button>
        }
      >
        <div className="mb-2 flex flex-col gap-2">
          <div className="flex justify-between">
            <div className="flex gap-4">
              <Dialog onOpenChange={(v) => setVisible(v)} open={visible}>
                <DialogTrigger asChild>
                  <Button className="bg-white" variant="outline">
                    Filters
                  </Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-[720px] max-h-[calc(100%-80px)] overflow-y-auto">
                  <DialogHeader>
                    <DialogTitle className="text-3xl">Filters</DialogTitle>
                  </DialogHeader>
                  <FiltersForm onSave={() => setVisible(false)} />
                  <DialogFooter>
                    <ActionButton
                      disabled={(!!filters && !Object.keys(filters)?.length) || !filters}
                      variant="link"
                      className="mr-auto"
                      eventKey="filters:clear"
                    >
                      Clear all
                    </ActionButton>
                    <ActionButton eventKey="filters:save" type="submit">
                      Show yachts
                    </ActionButton>
                  </DialogFooter>
                </DialogContent>
              </Dialog>
              <Button onClick={() => alert("FEATURE IN DEV")} className="bg-white hover:bg-white" variant="outline">
                Export
              </Button>
            </div>
            <div className="flex gap-x-4">
              <PageSizeSelect />
              <SortingSelect />
            </div>
          </div>
          <Outlet />
        </div>
      </Content>
    </ActionsContext>
  );
}

function PageSizeSelect() {
  const [value, setValue] = useState("40");
  const emit = useEmit<number>("ych:page-size");
  const pageChangeEmit = useEmit<number>("ych:page");

  const onValueChange = (value: string) => {
    pageChangeEmit(1);
    setValue(value);
    emit(parseInt(value));
  };

  return (
    <div className="w-60">
      <Select onValueChange={onValueChange} value={value}>
        <SelectTrigger>
          <SelectValue placeholder="Page size" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="10">Show: 10 at once</SelectItem>
          <SelectItem value="20">Show: 20 at once</SelectItem>
          <SelectItem value="40">Show: 40 at once</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}

function SortingSelect() {
  const [value, setValue] = useState("priceASC");
  const emit = useEmit<string>("ych:sorting");

  const onValueChange = (value: string) => {
    setValue(value);
    emit(value);
  };

  return (
    <div className="w-60">
      <Select onValueChange={onValueChange} value={value}>
        <SelectTrigger>
          <SelectValue placeholder="Page size" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="priceASC">Sort by: Price/week ascending</SelectItem>
          <SelectItem value="priceDESC">Sort by: Price/week descending</SelectItem>
          <SelectItem value="dateDESC">Sort by: Last modified</SelectItem>
          <SelectItem value="dateASC">Sort by: First modified</SelectItem>
          <SelectItem value="discountDESC">Sort by: Discount</SelectItem>
          <SelectItem value="nameASC">Sort by: Name [A-Z]</SelectItem>
          <SelectItem value="recommended">HELM recommended</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
